import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchMostViewedArticles as fetchMostViewedArticlesClient } from '../clients/kb-api.v3';
import Raven from 'raven-js';
export const fetchMostViewedArticles = createAsyncThunk('articles/fetchMostViewedArticles', kbId => fetchMostViewedArticlesClient(kbId).then(response => response ? response.results : []).catch(error => {
  Raven.captureException(error);
  throw error;
}));